const VARIANTS = {
  Normal: "bg-emerald-50 text-emerald-800 ring-emerald-600/15",
  Attention: "bg-amber-50 text-amber-900 ring-amber-500/20",
  Critical: "bg-red-50 text-red-800 ring-red-600/15",
  Pending: "bg-sky-50 text-sky-800 ring-sky-600/15",
  Urgent: "bg-red-50 text-red-800 ring-red-600/15",
  High: "bg-amber-50 text-amber-900 ring-amber-500/20",
  Medium: "bg-sky-50 text-sky-800 ring-sky-600/15",
  Routine: "bg-slate-100 text-slate-700 ring-slate-500/15",
  default: "bg-slate-100 text-slate-700 ring-slate-500/15"
};

export default function StatusBadge({ status, className = "" }) {
  const styles = VARIANTS[status] || VARIANTS.default;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset transition-colors ${styles} ${className}`}
    >
      {status}
    </span>
  );
}
